import { Helmet } from "react-helmet-async";

const TermsOfService = () => {
    return (
        <div className="m-auto bg-white px-8 py-10">
            <Helmet>
                <title>Terms & Conditions | RD Rental</title>
                <meta
                    name="description"
                    content="Read RD Rental’s terms and conditions governing the use of our vehicle rental management software, services, pricing, security, and user responsibilities."
                />
            </Helmet>

            <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center text-gray-800">
                Terms & Conditions
            </h1>

            <p className="text-gray-700 mb-6">
                Welcome to RD Rental. These Terms and Conditions govern your use of our rental management services and fleet. By using our platform and renting a vehicle with us, you agree to the following terms:
            </p>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Usage Policy</h2>
                <p className="text-gray-600">
                    Vehicles must be used responsibly and only for legal, personal, or business-related activities. Unauthorized uses—such as subleasing, or reckless driving—are strictly prohibited. Vehicles must be operated on well-maintained roads and returned in good condition.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Real-Time Tracking & Monitoring</h2>
                <p className="text-gray-600">
                    All RD Rental vehicles are GPS-enabled. By renting a vehicle, you consent to real-time tracking for operational efficiency, safety, and customer service improvement.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Maintenance and Condition</h2>
                <p className="text-gray-600">
                    Vehicles are regularly maintained. Renters are responsible for reporting any visible or mechanical issues immediately. Failure to report may result in charges. Scheduled maintenance alerts will be communicated as needed.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Pricing, Invoicing & Payments</h2>
                <p className="text-gray-600">
                    Charges are based on rental period, vehicle type, and location. Invoices are generated automatically. RD Rental accepts multiple payment methods. Late returns or damages may incur additional charges.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">5. Rental Plans</h2>
                <p className="text-gray-600">
                    We offer flexible rental plans, including daily and monthly options. Pricing and terms may vary depending on location, vehicle type, and duration. Please review available plans before booking.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">6. Insurance & Liability</h2>
                <p className="text-gray-600">
                    Renters are responsible for providing valid insurance that covers vehicle damage and personal injury. In the event of damage or an accident, you agree to cover deductibles and any uncovered costs. RD Rental is not liable for indirect damages or losses.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">7. Indemnification</h2>
                <p className="text-gray-600">
                    You agree to indemnify and hold RD Rental harmless from any liabilities, legal claims, fines, or damages arising out of your use of the rented vehicle.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">8. Termination</h2>
                <p className="text-gray-600">
                    We reserve the right to suspend or terminate your access to our services at any time for violations of these Terms or any illegal or harmful behavior.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">9. Jurisdiction</h2>
                <p className="text-gray-600">
                    These terms are governed by the applicable laws of the local jurisdiction. Any disputes shall be subject to the exclusive jurisdiction of the appropriate courts.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-semibold text-gray-800 mb-2">10. Amendments</h2>
                <p className="text-gray-600">
                    RD Rental reserves the right to update or modify these Terms at any time. Changes will be effective upon posting on our website. Continued use of our services constitutes acceptance of the updated terms.
                </p>
            </section>
        </div>
    );
};

export default TermsOfService;